/**
 * Menu / MenuItem overrides — CoordioDropdown option row language app-wide.
 *
 * Soft inset hover (Site dropdown), accent-subtle selected, no glass blur.
 * Applies to MUI Select menus and standalone Menus that share MuiMenu.
 */

import type { Theme } from '@mui/material/styles';
import type { Skin } from '../../@core/types';

const menu = (_skin: Skin): Theme['components'] => ({
  MuiMenu: {
    defaultProps: {
      slotProps: {
        paper: {
          elevation: 0,
        },
      },
    },
    styleOverrides: {
      paper: {
        marginBlockStart: '4px',
        minWidth: 260,
        maxWidth: 'min(96vw, 420px)',
        padding: '4px',
        borderRadius: '8px',
        border: '1px solid var(--color-border-default)',
        backgroundColor: 'var(--color-bg-surface)',
        backgroundImage: 'none',
        backdropFilter: 'none',
        WebkitBackdropFilter: 'none',
        boxShadow: 'var(--shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.12))',
      },
      list: {
        padding: 0,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        paddingBlock: '7px',
        paddingInline: '8px',
        marginInline: 0,
        marginBlockEnd: 0,
        gap: '8px',
        borderRadius: '4px',
        fontSize: '0.8125rem',
        lineHeight: 1.35,
        whiteSpace: 'normal',
        color: 'var(--color-text-primary)',
        transition: 'background-color 120ms ease, color 120ms ease',
        '& i, & svg': {
          fontSize: '1rem',
        },
        '& .MuiListItemIcon-root': {
          minInlineSize: 0,
        },
        '&:hover, &.Mui-focused, &.Mui-focusVisible': {
          backgroundColor: 'var(--color-bg-inset)',
          color: 'var(--color-text-primary)',
        },
        '&.Mui-selected': {
          backgroundColor: 'var(--color-accent-subtle)',
          color: 'var(--color-text-primary)',
          fontWeight: 500,
          '&:hover, &.Mui-focused, &.Mui-focusVisible': {
            backgroundColor: 'var(--color-accent-subtle)',
          },
          '& .MuiListItemIcon-root': {
            color: 'var(--color-accent-primary)',
          },
        },
        '&.Mui-disabled': {
          color: 'var(--color-text-disabled)',
          opacity: 0.45,
        },
      },
    },
  },
});

export default menu;
